import React from "react";
import PropTypes from "prop-types";
import Navigation from "./Navigation";

const Page = (props) => (
  <div>
    <Navigation enableGoBack={props.enableGoBack} title={props.title} />
    <div>{props.children}</div>
  </div>
);

Page.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  enableGoBack: PropTypes.bool,
};

export default Page;



// WEBPACK FOOTER //
// ./src/components/Page.js